export function getHashRoute(hash) {
  const raw = typeof hash === "string" ? hash : "";
  const trimmed = raw.startsWith("#") ? raw.slice(1) : raw;
  const path = trimmed.startsWith("/") ? trimmed : "/home";

  const segments = path.split("/").filter(Boolean);
  const [first, second] = segments;

  if (!first || first === "home") {
    return { name: "home", section: second };
  }

  if (first === "guides") return { name: "guides" };
  if (first === "tools") return { name: "tools" };
  if (first === "updates") return { name: "updates" };
  if (first === "post") return { name: "post", postId: second };

  return { name: "home", section: undefined };
}

export function toHashPath(path) {
  const safe = path.startsWith("/") ? path : `/${path}`;
  return `#${safe}`;
}
